import React, {useCallback, useMemo} from 'react';

import BuyerInfo from './BuyerInfo';
import {BuyerOrderListCellStyle} from './styles';
import CheckBoxCount from './CheckBoxCount';
import {ChevronRightIcon} from 'native-base';
import {DeliveryLocationStatus} from '@buncha/driver/types/common';
import {DriverScreens} from '@buncha/driver/navigation/type';
import {GroupedOrder} from '@buncha/driver/types/vanLoadAt';
import {HBox} from '@buncha/components/core/view';
import If from '@buncha/components/conditional/If';
import {MainScreens} from '@buncha/navigation/types';
import {PrinterMange} from '@buncha/components/type';
import StoreCheckList from './StoreCheckList';
import {Touchable} from '@buncha/components/core/touchable';
import {isWeb} from '@buncha/utils/common';
import {navigation} from '@buncha/config/navigation';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';
import {useRoute} from '@react-navigation/native';

interface CheckBoxCountProps {
  index: number;
  groupedOrder: GroupedOrder;
  openBluetoothSettingBottomSheet?: () => void;
  isBluetoothEnabled?: boolean;
}

const BuyerOrderListCell = (props: CheckBoxCountProps) => {
  const {index, groupedOrder} = props;
  const route = useRoute();
  const routeParams: {runId?: number} | undefined = route.params;
  const runId = routeParams?.runId || 0;
  const buyerId = groupedOrder?.buyer?.id ?? 0;

  const theme = useColorThemeType();
  const appState = useAppSelector(gbState => gbState);
  const bleDevice = appState.driver.BLEDevice;
  const disablePrinterFlow = appState.driver.disablePrinterFlow;
  const constatns = appState.onboarding.constants;
  const currentUserId = useAppSelector(
    gState => gState.onboarding.currentUser?.id,
  );

  const hasPrinterEnabled = useMemo(() => {
    let printerMange: PrinterMange | undefined;
    try {
      printerMange =
        constatns?.PRINTER_MANAGE && JSON.parse(constatns?.PRINTER_MANAGE);
    } catch (err: any) {
      printerMange = undefined;
    }
    if (!printerMange || !currentUserId) return false;
    if (printerMange.allUsers) return true;
    return printerMange.users?.includes(currentUserId);
  }, [constatns?.PRINTER_MANAGE, currentUserId]);

  const filteredOrders = useMemo(() => {
    const data = groupedOrder.orders.every(
      order =>
        order.deliveryLocation.deliveryStatus ===
        DeliveryLocationStatus.driverAssigned,
    );

    if (data) return true;
    return false;
  }, [groupedOrder]);

  const navigateToPrintBarcodeScreen = useCallback(() => {
    if (isWeb() || !hasPrinterEnabled || disablePrinterFlow) return;
    const isBLEAddressMissing = !bleDevice?.address;
    if (!props?.isBluetoothEnabled || isBLEAddressMissing)
      if (props.openBluetoothSettingBottomSheet) {
        props.openBluetoothSettingBottomSheet();
        return;
      }

    navigation.navigate(MainScreens.Driver, {
      screen: DriverScreens.PrintScanBarcodes,
      params: {runId, buyerId},
    });
  }, [
    hasPrinterEnabled,
    disablePrinterFlow,
    bleDevice?.address,
    props,
    runId,
    buyerId,
  ]);

  return (
    <Touchable
      onPress={navigateToPrintBarcodeScreen}
      style={BuyerOrderListCellStyle.mainContainer}>
      <HBox style={BuyerOrderListCellStyle.container}>
        <CheckBoxCount index={index} isChecked={filteredOrders} />
        <BuyerInfo
          index={index}
          buyer={groupedOrder?.buyer}
          orders={groupedOrder?.orders}
        />
        <StoreCheckList
          orders={groupedOrder?.orders}
          index={props?.index}
          buyer={groupedOrder?.buyer}
        />
      </HBox>
      <If condition={!isWeb() && hasPrinterEnabled && !disablePrinterFlow}>
        <ChevronRightIcon
          color={theme?.text.gray[100]}
          style={BuyerOrderListCellStyle.iconStyle}
          size={'md'}
        />
      </If>
    </Touchable>
  );
};

export default React.memo(BuyerOrderListCell);
